export interface Card {
  token: string;
  brand: string;
  last4: string;
  expiryYear: number;
  expiryMonth: number;
}

export const defaultCard = {
  token: '',
  brand: '',
  expiryMonth: 0,
  expiryYear: 0,
  last4: '',
};
